module.exports = __webpack_public_path__ + "static/img/6.6c3f0c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/zh/6.png
// module id = wTeT
// module chunks = 0